<template>
    <div class="sw-modal trip-details">
        <div v-click-outside="close" v-on:click.stop class="sw-modal-content" v-bind:class="{'text-temporary': isEnquiry || isBlockOut || isCancelled}">
            <div class="row sw-modal-heading">
                <div class="col text-center">
                    <h4><i class="fas fa-suitcase"></i>
                        <template v-if="isEnquiry">Enquiry</template>
                        <template v-else-if="isBlockOut">Block out</template>
                        <template v-else-if="isMigrating">Booking (migrating)</template>
                        <template v-else-if="isRequestingAmendment">Booking (amending)</template>
                        <template v-else-if="isCancelled">Booking (cancelled)</template>
                        <template v-else>Booking</template>
                    </h4>
                </div>
            </div>
            <div class="sw-modal-body">
                <template v-if="loading">
                    <Spinner/>
                </template>

                <template v-else>
                    <template v-if="errorMessage">
                        <div class="row">
                            <div class="col-12 infobar infobar-error">{{errorMessage}}</div>
                        </div>
                    </template>

                    <template v-else>
                        <div class="row sw-modal-sub-heading">
                            <div class="col-2 text-center"><i class="fas fa-calendar-alt"></i></div>
                            <div class="col-10">Dates</div>
                        </div>
                        <div class="row">
                            <div class="col-2 text-center"><i class="fas fa-door-open"></i></div>
                            <div class="col-3">Arrive:</div>
                            <div class="col-7 text-left sw-modal-date">{{friendlyDateFull(detailedBooking.arrival)}}</div>
                        </div>
                        <div class="row">
                            <div class="col-6 offset-6 text"></div>
                        </div>
                        <div class="row">
                            <div class="col-2 text-center"><i class="fas fa-door-closed"></i></div>
                            <div class="col-3">Depart:</div>
                            <div class="col-7 text-left sw-modal-date">{{friendlyDateFull(detailedBooking.departure)}}</div>
                        </div>

                        <div class="row">
                            <div class="col"><hr/></div>
                        </div>

                        <div class="row sw-modal-sub-heading">
                            <div class="col-2 text-center"><i class="fas fa-users"></i></div>
                            <div class="col-10">Booking contact</div>
                        </div>
                        <div class="row">
                            <div class="col-2 text-center"><i class="fas fa-user"></i></div>
                            <div class="col-10"><guest-name v-bind:guest="detailedBooking.bookedBy" v-bind:highlightIfMissing="true"></guest-name></div>
                        </div>
                        <div class="row">
                            <div class="col-2 text-center"><i class="fas fa-envelope"></i></div>
                            <div class="col-10"><field-with-not-supplied-fallback v-bind:value="detailedBooking.bookedBy.email" v-bind:highlightIfMissing="true"></field-with-not-supplied-fallback></div>
                        </div>
                        <div class="row">
                            <div class="col-2 text-center"><i class="fas fa-phone"></i></div>
                            <div class="col-10"><field-with-not-supplied-fallback v-bind:value="detailedBooking.bookedBy.mobile" v-bind:highlightIfMissing="true"></field-with-not-supplied-fallback></div>
                        </div>
                        <div class="row">
                            <div class="col-2 text-center"><i class="fas fa-calendar-alt"></i></div>
                            <div class="col-10">Booked on {{friendlyDateAndTime(detailedBooking.dateBooked)}}</div>
                        </div>
                        <div v-if="detailedBooking.channel" class="row">
                            <div class="col-2 text-center"><i class="fas fa-hands-helping"></i></div>
                            <div class="col-10">
                                via {{detailedBooking.channel.providerChannelName}}
                                <span v-if="detailedBooking.externalBookingId">(ID:
                                  {{detailedBooking.externalBookingId}}
                                  <template v-if="detailedBooking.externalEstablishmentBookingId">• {{detailedBooking.externalEstablishmentBookingId}}</template>
                                  )
                                </span>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col"><hr/></div>
                        </div>

                        <div class="row sw-modal-sub-heading trip-details__rooms">
                            <div class="col-2 text-center"><i class="fas fa-house-user"></i></div>
                            <div class="col-8"><span class="capitalize">{{getUnitTypeForDisplay}}</span> & Guests</div>
                            <div class="col-2 text-center">
        <!--                        <button class="btn btn-primary" v-on:click.stop><i class="fas fa-comments"></i></button>-->
                            </div>
                        </div>
                        <TripDetailsRoom v-for="(room, index) in detailedBooking.rooms" v-bind:key="index" v-bind:room="room"></TripDetailsRoom>

                        <div class="row">
                            <div class="col"><hr/></div>
                        </div>

                        <div class="row sw-modal-sub-heading">
                            <div class="col-2 text-center"><i class="fas fa-coins"></i></div>
                            <div class="col-10 sw-modal-sub-heading">Pricing</div>
                        </div>
                        <div class="row trip-details__pricing">
                            <div class="col-2 text-center"></div>
                            <div class="col-10">
                                <table>
                                    <thead></thead>
                                    <tr v-for="(room, index) in detailedBooking.rooms" v-bind:key="index" v-bind:room="room">
                                        <td>{{room.roomTypeName}}</td>
                                        <td class="text-right" v-bind:class="{'trip-details__pricing__last-room' : index === detailedBooking.rooms.length - 1}">{{detailedBooking.currencyCode}} {{room.roomRateTotal}}</td>
                                    </tr>
                                    <template v-if="hasPricingComponentsOtherThanAccommodation">
                                      <tr>
                                        <td>Accommodation</td>
                                        <td class="text-right">{{detailedBooking.currencyCode}} {{detailedBooking.total}} </td>
                                      </tr>
                                      <tr v-if="hasExtrasTotal">
                                        <td>Extras</td>
                                        <td class="text-right">{{detailedBooking.currencyCode}} {{detailedBooking.extrasTotal}} </td>
                                      </tr>
                                      <tr v-if="hasCleaningFeeTotal">
                                        <td>Cleaning fee</td>
                                        <td class="text-right">{{detailedBooking.currencyCode}} {{detailedBooking.cleaningFeeTotal}} </td>
                                      </tr>
                                      <tr>
                                        <td>Total price</td>
                                        <td class="text-right trip-details__pricing__total">{{detailedBooking.currencyCode}} {{detailedBooking.totalPrice}} </td>
                                      </tr>
                                    </template>
                                    <template v-else>
                                      <tr>
                                        <td>Total</td>
                                        <td class="text-right">{{detailedBooking.currencyCode}} {{detailedBooking.total}} </td>
                                      </tr>
                                    </template>
                                    <tr>
                                        <td>Deposit</td>
                                        <td class="text-right">{{detailedBooking.currencyCode}} {{detailedBooking.deposit}} </td>
                                    </tr>
                                </table>
                            </div>
                        </div>

<!--                        <div class="row">-->
<!--                            <div class="col"><hr/></div>-->
<!--                        </div>-->
<!--                        <div class="row sw-modal-sub-heading">-->
<!--                            <div class="col-2 text-center"><i class="fas fa-tasks"></i></div>-->
<!--                            <div class="col-10 sw-modal-sub-heading">Requests</div>-->
<!--                        </div>-->
<!--                        <div class="row">-->
<!--                            <div class="col-10"></div>-->
<!--                        </div>-->

                        <div class="row">
                            <div class="col"><hr/></div>
                        </div>

                        <div class="row sw-modal-sub-heading">
                            <div class="col-2 text-center"><i class="far fa-calendar-alt"></i></div>
                            <div class="col-10 sw-modal-sub-heading">Tasks</div>
                        </div>
                        <ul class="trip-details__tasks hover-button-hover-container">
                            <li v-for="(task, index) in detailedBooking.tasks" v-bind:key="index" v-bind:class="{'text-cancelled': isCancelledForTask(task)}">
                                <div class="row">
                                    <div class="col-2 text-center task-icon" v-on:click.stop="openTask(task)">
                                        <div class="icons-layered">
<!--                                        <span class="tooltip-container">-->
                                            <span v-html="taskIconForTask(task)"></span>
                                            <span v-html="stateIconForTask(task)"></span>
<!--                                        </span>-->
                                        </div>
                                    </div>
                                    <div class="col-6 task-name" v-on:click.stop="openTask(task)">
                                        {{taskNameForTask(task)}}
                                    </div>
                                    <div class="col-4 text-right" v-on:click.stop="goToTask(task)">
                                        <button class="hover-button">
                                            <i class="far fa-calendar-alt"></i>
                                        </button>
                                    </div>
                                </div>
                            </li>
                        </ul>

                        <div class="row">
                            <div class="col"><hr/></div>
                        </div>

                        <div class="row sw-modal-sub-heading">
                            <div class="col-2 text-center"><i class="fas fa-history"></i></div>
                            <div class="col-8 sw-modal-sub-heading">
                                History
                                <span class="text-note">({{detailedBooking.logEntries.length}} entries)</span>
                            </div>
                            <div class="col-2 text-right">
                                <i class="fa fa-chevron-down" v-show="!historyExpanded" v-on:click.stop="toggleHistory"></i>
                                <i class="fa fa-chevron-up" v-show="historyExpanded" v-on:click.stop="toggleHistory"></i>
                            </div>
                        </div>
                        <div v-show="historyExpanded" class="row">
                            <div class="col-12">
                                <ul class="history__log">
                                    <li v-for="(logEntry, index) in detailedBooking.logEntries.slice().reverse()" v-bind:key="index">
                                        <div class="history__log__meta">
                                            <span>{{friendlyDateAndTime(logEntry.created)}}</span>
                                            <span>{{getSource(logEntry)}}</span>
<!--                                            <span>{{getSource(logEntry)}}</span>-->
                                        </div>
                                        <div class="history__log__details">
                                            <div class="history__log__details__type">{{logEntry.type}}</div>
                                            <div v-if="logEntry.detail" v-bind:inner-html.prop="logEntry.detail | marked"></div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 text-center"><button class="btn btn-primary" v-on:click.stop="close">Close</button></div>
                        </div>
                    </template>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import * as dayjs from 'dayjs'

    import { store, getters } from '../../store.js'

    import Spinner from '../Spinner.vue'
    import GuestName from '../GuestName'
    import FieldWithNotSuppliedFallback from '../FieldWithNotSuppliedFallback'

    import TripDetailsRoom from './TripDetailsRoom'

    import { bookingsMixin } from '../../mixins/BookingsMixin'
    import { tasksMixin } from '../../mixins/TasksMixin'
    import { datesMixin } from "../../mixins/DatesMixin"

    export default {
        name: 'TripDetails',
        components: {
            Spinner, GuestName, FieldWithNotSuppliedFallback, TripDetailsRoom
        },
        mixins: [ bookingsMixin, tasksMixin, datesMixin ],
        props: {
            booking: Object
        },
        data: function () {
            return {
                loading: true,
                errorMessage: null,
                detailedBooking: null,
                historyExpanded: false,
            }
        },
        computed: {
            getUnitTypeForDisplay: function() {
                return getters.getCurrentEstablishment().preferences.displayCategoryForRoomTypes;
            },
            hasExtrasTotal: function() {
                return this.detailedBooking.extrasTotal && this.detailedBooking.extrasTotal != '0.00';
            },
            hasCleaningFeeTotal: function() {
                return this.detailedBooking.cleaningFeeTotal && this.detailedBooking.cleaningFeeTotal != '0.00';
            },
            hasPricingComponentsOtherThanAccommodation: function() {
                return this.hasExtrasTotal || this.hasCleaningFeeTotal;
            }
        },
        methods: {
            toggleHistory: function () {
                this.historyExpanded = !this.historyExpanded
            },
            getSource: function(logEntry) {
                switch (logEntry.source) {
                    case 'host':
                        return logEntry.host;
                    default:
                        return logEntry.source;
                }
            },
            loadBookingDetails: function() {
                this.$http.get('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/bookings/' + this.booking.reference, {
                    withCredentials: true
                }).then(response => {
                    if (response.data) {
                        this.detailedBooking = response.data;
                        const numberOfNights = dayjs(this.detailedBooking.departure).diff(dayjs(this.detailedBooking.arrival), 'day');
                        for (let room of this.detailedBooking.rooms) {
                            Vue.set(room, 'roomRateTotal', (Math.round((room.roomRate * numberOfNights) * 100) / 100).toFixed(2));
                        }
                        this.sortByScheduledDate(this.detailedBooking.tasks);
                    }
                }).catch(error => {
                    console.log(error);
                    this.errorMessage = "There was an error loading the trip details";
                }).finally(() => {
                    this.loading = false
                })
            },
            // goToForm: function(task) {
            //     console.log("Jumping to form: " + task.);
            // },
            openTask: function(task) {
                this.$root.$emit('open-task-details', task);
                this.close();
            },
            goToTask: function(task) {
                const jump = dayjs(task.scheduledDate);
                console.log("Jumping to date: " + jump);
                this.$router.push({name: 'JumpToDateOnTaskCalendar',
                    params: {
                        year: jump.format("YYYY"),
                        month: jump.format("M"),
                        day: jump.format("D"),
                    }
                });
                this.close();
            },
            close: function () {
                console.log("close trip");
                this.$root.$emit('finished-viewing-trip-details');
            },
        },
        mounted() {
            this.loadBookingDetails();
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/components/modal";
    @import "../../styles/components/task";
    @import "../../styles/components/trip_details";
</style>